/*
 * Rennsieger — Make an Inquiry form.
 *
 * Progressive disclosure: the topic you pick reveals only the fields that matter
 * (order number for order help, vehicle for a fitment check, company for wholesale),
 * so the form starts short and stays relevant. Conditional fields are never `required`,
 * so a hidden field can't block submission. Real submission is Shopify's contact form.
 * No dependencies; no-ops when its markup is absent.
 */
(function () {
  'use strict';

  var root = document.querySelector('.rsg-inq');
  if (!root) return;

  var topic = root.querySelector('[data-rsg-inq-topic]');
  var conds = Array.prototype.slice.call(root.querySelectorAll('[data-rsg-inq-cond]'));
  if (!topic || !conds.length) return;

  function sync() {
    var val = topic.value;
    conds.forEach(function (el) {
      var when = (el.getAttribute('data-when') || '').split('|').map(function (s) { return s.trim(); });
      el.classList.toggle('is-on', when.indexOf(val) !== -1);
    });
  }

  topic.addEventListener('change', sync);
  sync();

  // If the page loaded on the success state, scroll it into view politely.
  var success = root.querySelector('[data-rsg-inq-success]');
  if (success && typeof success.scrollIntoView === 'function') {
    try { success.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
  }
})();
